<template>
  <div class="section section-institucional-detalle">
    <div class="container">
      <span v-html="autoridades"></span>
    </div>
  </div>
</template>
<script>
import { Card, Tabs, TabPane } from "@/components";

export default {
  components: {
    Card,
    Tabs,
    TabPane
  },
  data() {
    return {
      model: {}
    };
  },
  async created() {
    await this.$store.dispatch("resource/getAll");
  },
  computed: {
    autoridades() {
      return this.$store.getters["resource/getByName"]("Autoridades").value;
    }
  }
};
</script>
<style scoped>
div.section {
  padding: 40px 0;
}
</style>